import React from "react";
import "./AboutHero.css";
import photo2 from "../../assets/OURSERVICE/mice.webp";

function AboutHero() {
  return (
    <div
      className="about-hero"
      style={{
        backgroundImage: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(${photo2})`,
      }}
    >
      <h1>About Us</h1>
      <p>Creating Journeys, Not Just Trips</p>
    </div>
  );
}

export default AboutHero;